import $ from 'jquery';

$(document).ready(function () {
	const searchInput = $(`.wp-block-search input.wp-block-search__input`);
	searchInput.attr('onchange', "this.setCustomValidity('')");
	searchInput.attr(
		'oninvalid',
		"this.setCustomValidity('Enter at least more than two characters')"
	);
	searchInput.attr('pattern', '.{3,}');
});
